<template>
  <section class="about" id="about">
    <div class="container">
      <!-- Title  -->
      <h1 class="title">Chi Siamo</h1>

      <!-- Text  -->
      <p class="paragraph">
        Da oltre 20 anni Climacool opera nel settore della climatizzazione
        fornendo assistenza ad alcuni dei migliori marchi in circolazione,
        partendo con il solo marchio LG nella provincia di Ancona, negli anni ha
        ottenuto l'autorizzazione a coprire tutta la regione Marche in qualità
        di Centro Pilota espandendosi anche ad altri marchi: Mitsubishi,
        Samsung, Hitachi, Hisense, Olimpia Splendid, Midea e Fantini Cosmi ed
        aprendo nel 2010 a Milano sotto il nome di Climaline srl.
      </p>

      <!-- Company Image  -->
      <!--  Per quando avremo delle belle foto  -->
      <!-- <div class="company-image d-none d-lg-block">
                <img src="../assets/images/company.jpg" alt="company photo">
            </div> -->
    </div>
  </section>
</template>

<script>
export default {
  name: "About",
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.about {
  background-color: $brand_primary_color;
  color: white;

  .title {
    color: white;
  }

  // .company-image {
  //     width: 40%;
  //     margin: auto;
  // }
}
</style>
